import { VSpacer } from '@/components/DesignSystem';
import { AppHeader } from '@/components/shared/AppHeader';
import { Routes } from '@/constants/Routes';
import { PasswordResetPage } from '@/pages/Auth/PasswordResetPage';
import { VerifyEmail } from '@/pages/Auth/VerifyEmail';
import { BenefitsPage } from '@/pages/CustomerDashboard/BenefitsPage';
import { CustomerDashboard } from '@/pages/CustomerDashboard/CustomerDashboard';
import { FaqPage } from '@/pages/CustomerDashboard/FaqPage';
import { HowItWorksPage } from '@/pages/CustomerDashboard/HowItWorksPage';
import { PromotionsPage } from '@/pages/CustomerDashboard/Promotions/PromotionsPage';
import { WalletPage } from '@/pages/CustomerDashboard/WalletPage';
import React from 'react';
import { Route, Routes as AppRoutes } from 'react-router-dom';

export const PublicView = () => {

  const createLayout = (element: React.ReactNode) => {
    return (
      <>
        <AppHeader />
        <VSpacer size="11" />
        {element}
      </>
    );
  };

  return (
    <AppRoutes>
      <Route element={createLayout(<VerifyEmail />)} path={Routes.VERIFY_EMAIL} />
      <Route element={<CustomerDashboard />} path={Routes.CUSTOMER_DASHBOARD} />
      <Route element={<CustomerDashboard />} path={Routes.CUSTOMER_DASHBOARD_ALT} />
      <Route element={<BenefitsPage />} path={Routes.CUSTOMER_DASHBOARD_BENEFITS} />
      <Route element={<BenefitsPage />} path={Routes.CUSTOMER_DASHBOARD_BENEFITS_ALT} />
      <Route element={<FaqPage />} path={Routes.CUSTOMER_DASHBOARD_FAQ} />
      <Route element={<FaqPage />} path={Routes.CUSTOMER_DASHBOARD_FAQ_ALT} />
      <Route element={<HowItWorksPage />} path={Routes.CUSTOMER_DASHBOARD_HOW_IT_WORKS_ALT} />
      <Route element={<HowItWorksPage />} path={Routes.CUSTOMER_DASHBOARD_HOW_IT_WORKS} />
      <Route element={<PasswordResetPage />} path={Routes.CREATE_PASSWORD} />
      <Route element={<PasswordResetPage />} path={Routes.RESET_PASSWORD} />
      <Route element={<WalletPage />} path={Routes.CUSTOMER_DASHBOARD_WALLET} />
      <Route element={<WalletPage />} path={Routes.CUSTOMER_DASHBOARD_WALLET_ALT} />
      <Route element={<PromotionsPage />} path={Routes.CUSTOMER_DASHBOARD_PROMOTIONS} />
      <Route element={<PromotionsPage />} path={Routes.CUSTOMER_DASHBOARD_PROMOTIONS_ALT} />
    </AppRoutes>
  );
};
